module.exports = __webpack_public_path__ + "static/hyperv_41.75d64f83.jpg";